import axios from "axios"
import { AD_COPIES_URL } from "src/constants"

export const getAdCopies = async (userId) => {
   return await axios.get(`${AD_COPIES_URL}?userId=${userId}`)
}
